import React from 'react';

export default ({
  pathClass = ''
}) => (
  <svg width="12" height="8" viewBox="0 0 12 8">
    <path className={pathClass} d="M1.757 2L6 6.243 10.243 2" stroke="#111" strokeWidth="2" fill="none" />
  </svg>
)